import React, { useEffect } from "react";
import { ActivityCertificateFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const ActivityCertificateForm = ({ initialValues, onSubmit }) => {
  const { t } = useTranslation(["common"]);

  const schema = yup.object().shape({
    first_name: yup.string().trim().required(t("Required", { ns: "common" })),
    last_name: yup.string().trim().required(t("Required", { ns: "common" })),
    email: yup
      .string()
      .trim()
      .email(t("Invalid email", { ns: "common" }))
      .required(t("Required", { ns: "common" })),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (initialValues) {
      reset({ ...initialValues });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ActivityCertificateFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={t("First name", { ns: "common" })}
                errors={errors.first_name?.message}
              />
            )}
            name="first_name"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={t("Last name", { ns: "common" })}
                errors={errors.last_name?.message}
              />
            )}
            name="last_name"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={t("Email (for receiving image files)", {
                  ns: "common",
                })}
                errors={errors.email?.message}
              />
            )}
            name="email"
            defaultValue=""
          />
        </div>
        <div className="btn_wrap">
          <Buttons.BgStandard
            type="submit"
            label={t("Confirm", { ns: "common" })}
          />
        </div>
      </form>
    </ActivityCertificateFormStyled>
  );
};

ActivityCertificateForm.propTypes = {};

export default ActivityCertificateForm;
